export default "__VITE_ASSET__DJmHNqOy__"